import { http } from '@/plugins/api';

const base = 'transaction-composer';


export const getListReportPPD1 = payload => {
  const url = `/${base}/download/reportppdaxi?nomor_axi=${payload.nomor_axi}&periode=${payload.periode}`
  const headers = {
    'Accept': 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  return http.get(url, {
    headers
  });

}

